import { get, isNil } from 'lodash-es';

import { ColorRuleProps, MatchValue } from '../../../core/types/color-rule.js';
import type {
  XYChartSeriesWithDatapoints,
  ColorRuleValidator,
} from '../../types/xy-chart-internals.js';
import { getFallbackValueAccessor } from '../get-fallback-value-accessor.js';

export const hasSeriesMatchingDatapoint = (
  series: XYChartSeriesWithDatapoints,
  rule: ColorRuleProps,
  isValid: ColorRuleValidator,
): boolean => {
  const accessor = rule.valueAccessor ?? getFallbackValueAccessor(series);

  return series.data.some((datapoint) => {
    const subject = get(datapoint, accessor) as MatchValue;
    return (
      !isNil(subject) && isValid(subject, rule.comparator, rule.matchValue)
    );
  });
};
